import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const publishUnpublishReview = {
  name: "publishUnpublishReview" as const,
  input: z.object({
    _id: z.string(),
    teamId: z.string(),
    action: createEnum(["publish", "unpublish"]),
  }),
  output: z.literal("success"),
};
